import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { APIHelper } from '../../../../../../../shared/services/api-helper/api-helper.service';
import { API_URLS } from '../../../../../../../environments/env-routes';
import { MOMENT_TOKEN } from '../../../../../../shared/shared.module';
import { DialogDownloadFileComponent } from '../dialog-download-file/dialog-download-file.component';
import { DialogDownloadZipComponent } from '../dialog-download-zip/dialog-download-zip.component';
import { StorageService } from '../../../../../../../shared/services/storage/storage.service';

@Component({
  selector: 'dialog-see-versions',
  templateUrl: './dialog-see-versions.component.html',
  styleUrls: ['./dialog-see-versions.component.scss']
})
export class DialogSeeVersionsComponent implements OnInit {
  public loading: boolean;
  public file: any;
  public filesVersions: any[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogSeeVersionsComponent>,
    private api: APIHelper,
    @Inject(MOMENT_TOKEN) public moment,
    private dialog: MatDialog,
    private storage: StorageService
  ) {
  }

  ngOnInit() {
    this.loading = false;
    this.file = this.data.file;
    this.filesVersions = [];

    this.getVersions();
  }

  getVersions() {
    this.loading = true;

    this.api.requestApi({action: API_URLS.versions.getFiles, queryArgs: `nodeRef=workspace://SpacesStore/${this.file.id}`})
      .then((res) => {
        this.filesVersions = res.map(el => {
          return {...el, createdDateISO: new Date(el.createdDateISO)};
        });
      })
      .finally(() => this.loading = false);
  }

  download(file) {
    const token = this.storage.getAsync({key: 'token'});
    const nodeId = file.nodeRef.split('/').slice(-1)[0];
    let url = this.api.url + API_URLS.versions.downloadVersion.replace(':versionNodeId', nodeId).replace(':filename', file.name);
    url += `?attachment=true&alf_ticket=${token}&a=true`;

    window.open(url, '_blank');
    this.dialogRef.close(true);
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
